export const GRAPHQL_API_URI = 'https://api.retteweb.f2.net/graphql';
